// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { Coding } from '@medplum/fhirtypes';

/** Official Medplum extension for recurring scheduling configuration. */
export const SCHEDULING_PARAMETERS_EXTENSION_URL = 'https://medplum.com/fhir/StructureDefinition/SchedulingParameters';

/** Official Medplum extension linking Appointment.serviceType to HealthcareService. */
export const SERVICE_TYPE_REFERENCE_EXTENSION_URL = 'https://medplum.com/fhir/service-type-reference';

/** Official FHIR timezone extension used by Medplum scheduling operations. */
export const FHIR_TIMEZONE_EXTENSION_URL = 'http://hl7.org/fhir/StructureDefinition/timezone';

export const SCHEDULING_OPERATION_NAMES = {
  find: '$find',
  book: '$book',
  hold: '$hold',
  confirm: '$confirm',
  cancel: '$cancel',
} as const;

/** Stable Polaris provenance marker for appointments created by the v2 engine. */
export const SCHEDULING_V2_PROVENANCE_SYSTEM = 'https://polarissleep.com/scheduling-engine';
export const SCHEDULING_V2_PROVENANCE_CODE = 'medplum-v2';
export const SCHEDULING_V2_PROVENANCE_TAG: Coding = {
  system: SCHEDULING_V2_PROVENANCE_SYSTEM,
  code: SCHEDULING_V2_PROVENANCE_CODE,
  display: 'Medplum scheduling v2',
};

/** Marks Appointments created by the slot hold service so expired holds can be found and released. */
export const SLOT_HOLD_TAG: Coding = {
  system: 'https://polarissleep.com/scheduling-hold',
  code: 'slot-hold',
  display: 'Slot hold',
};
/** Instant after which a held Appointment may no longer be confirmed. */
export const SLOT_HOLD_EXPIRES_AT_EXTENSION_URL =
  'https://polarissleep.com/fhir/StructureDefinition/slot-hold-expires-at';
export const SLOT_HOLD_DURATION_MS = 15 * 60 * 1000;
/** Holds are only swept this long after expiry so a confirm that passed its expiry check can finish first. */
export const SLOT_HOLD_RELEASE_GRACE_MS = 60 * 1000;

/** Environment marker shared by tenant-scoped Polaris resources. */
export const POLARIS_ENV_TAG_SYSTEM = 'https://polarissleep.com/env';

export const FHIR_JSON_CONTENT_TYPE = 'application/fhir+json';
export const FHIR_BASE_PATH = '/R4';
export const MAX_FIND_WINDOW_DAYS = 31;
export const MAX_FIND_COUNT = 1000;
/** Maximum single-page reconciliation search; use searchResourcePages when available. */
export const MAX_PROJECTION_SEARCH_COUNT = 1000;
